module.exports = __webpack_public_path__ + "static/media/cvReloj.15ade749.svg";